import moment from 'moment-timezone';

export function initMoment(timezone = moment.tz.guess()) {
  moment.tz.setDefault(timezone);
}
